import React from 'react';
import PrintText from './PrintText';
import { Field } from 'redux-form/immutable';
import { renderField } from './_FORM_FIELDS';
import { FormText, FormGroup, Input, Label, FormFeedback } from 'reactstrap';
import PropTypes from 'prop-types';

class Password extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            password: '',
            confirmPassword: '',
            validPassword: false,
            disablePwd: false,
            validOldPassword: true,
            passwordRules: {
                uppercase: false,
                lowercase: false,
                number: false,
                special: false
            }
        }
    }


    passwordFunc = (e) => {
        const { layoutItem: { itemProperties: { passwordConfig } } } = this.props;
        const password = e.target.value;
        if (passwordConfig && passwordConfig.strongPassord) {
            const passwordRules = {
                uppercase: /[A-Z]/.test(password),
                lowercase: /[a-z]/.test(password),
                number: /\d/.test(password),
                special: /[!@#$%^&*(),.?":{}|<>]/.test(password)
            };

            const isPasswordStrong =
                passwordRules.uppercase &&
                passwordRules.lowercase &&
                passwordRules.number &&
                passwordRules.special;

            const passwordsMatch =
                password === this.state.confirmPassword;

            this.setState({
                password,
                passwordRules,
                validPassword: passwordsMatch && isPasswordStrong
            });

            this.props.toggleSaveandNextState(
                !(passwordsMatch && isPasswordStrong)
            );
        } else {
            this.setState({ password: e.target.value }, () => {
                if (this.state.password.localeCompare(this.state.confirmPassword) === 0) {
                    this.setState({ validPassword: true })
                    this.props.toggleSaveandNextState(false)
                } else {
                    this.setState({ validPassword: false })
                    this.props.toggleSaveandNextState(true)
                }
            })
        }
    }

    passwordFuncWithoutConfirmPassword = (e) => {
        this.setState({ password: e.target.value })
    }
    confirmPasswordFunc = (e) => {

        const { layoutItem: { itemProperties: { passwordConfig } } } = this.props;
        const confirmPassword = e.target.value;
        if (passwordConfig && passwordConfig.strongPassord) {
            const {
                uppercase,
                lowercase,
                number,
                special
            } = this.state.passwordRules;

            const isPasswordStrong =
                uppercase &&
                lowercase &&
                number &&
                special;

            const passwordsMatch =
                this.state.password === confirmPassword;

            this.setState({
                confirmPassword,
                validPassword: passwordsMatch && isPasswordStrong
            });

            this.props.toggleSaveandNextState(
                !(passwordsMatch && isPasswordStrong)
            );
        } else {
            this.setState({ confirmPassword: e.target.value }, () => {
                if (this.state.password.localeCompare(this.state.confirmPassword) === 0) {
                    this.setState({ validPassword: true })
                    this.props.toggleSaveandNextState(false)
                } else {
                    this.setState({ validPassword: false })
                    this.props.toggleSaveandNextState(true)
                }

            })
        }

    }

    confirmOldPassword = (e) => {
        const user = this.props.user;
        const password = e.target.value;

        if (password.length >= 4) {
            this.props.verifyOldPwd({
                email: user && user.user ? user.user.email : '',
                password
            });
        }
    };

    componentDidMount() {
        const { toggleSaveandNextState, user } = this.props;
        const { layoutItem: { itemProperties: { passwordConfig, field: { properties } } } } = this.props;

        if (passwordConfig && passwordConfig.confirmPassword) {

            toggleSaveandNextState(true)
        }
        if (passwordConfig && passwordConfig.oldPassword) {

            this.setState({ disablePwd: true })
        }
        if (passwordConfig && passwordConfig.emailField) {
            const email = user && user.user ? user.user.email : '';
            this.props.change(passwordConfig.emailField, email)
        }
    }

    componentWillReceiveProps(nextProps) {
        const { oldPassword } = nextProps;
        if (oldPassword && oldPassword.data && !oldPassword.data.status) {
            this.setState({ validOldPassword: false, disablePwd: true })
        } else if (oldPassword && oldPassword.data && oldPassword.data.status) {
            this.setState({ disablePwd: false, validOldPassword: true })
        }
    }

    render() {
        const { classProperty, type, validations, value, isReadOne, initialValues, ...rest } = this.props;
        const { layoutItem: { itemProperties: { passwordConfig, field: { properties } } } } = this.props;
        const { password, confirmPassword, disablePwd, validOldPassword } = this.state;

        return (
            <div className='password-container'>
                {
                    isReadOne ?
                        <PrintText {...this.props} /> :
                        <div>
                            {passwordConfig && passwordConfig.oldPassword && <FormGroup>
                                <Label for={'oldPassword'}>Enter Old Password</Label>
                                <Input
                                    type="password"
                                    placeholder="Old Password"
                                    onChange={this.confirmOldPassword}

                                />
                                {!(this.state.validOldPassword) ? (
                                    <FormFeedback className='animated fadeIn d-block'>
                                        <i className='fa fa-exclamation-triangle' aria-hidden='true'></i>{' '}
                                        Old Password is not correct
                                    </FormFeedback>
                                ) : (
                                    ''
                                )}
                            </FormGroup>
                            }
                            <div style={{ marginBottom: 30 }}>
                                <Field
                                    name={classProperty}
                                    component={renderField}
                                    type="password"
                                    validate={validations}
                                    value={value}
                                    fieldType={type}
                                    disabled={disablePwd}
                                    onChangeInput={passwordConfig && passwordConfig.confirmPassword ? this.passwordFunc : this.passwordFuncWithoutConfirmPassword}
                                    {...rest}
                                />
                                {passwordConfig && passwordConfig.strongPassord && <div className="mt-2">

                                    <div className={this.state.passwordRules.uppercase ? "text-success" : "text-danger"}>
                                        • One uppercase character
                                    </div>

                                    <div className={this.state.passwordRules.lowercase ? "text-success" : "text-danger"}>
                                        • One lowercase character
                                    </div>

                                    <div className={this.state.passwordRules.special ? "text-success" : "text-danger"}>
                                        • One special character
                                    </div>

                                    <div className={this.state.passwordRules.number ? "text-success" : "text-danger"}>
                                        • One number
                                    </div>

                                </div>
                                }
                            </div>

                            {
                                passwordConfig && passwordConfig.confirmPassword && <FormGroup>
                                    {passwordConfig && passwordConfig.confirmPasswordLabelText && <Label for={'confirmPassword'}>{passwordConfig.confirmPasswordLabelText}</Label>}
                                    <Input
                                        type="password"
                                        placeholder={passwordConfig && passwordConfig.confirmPasswordPlaceholderText ? passwordConfig.confirmPasswordPlaceholderText : ""}
                                        onChange={this.confirmPasswordFunc}
                                        disabled={disablePwd}
                                    />
                                    {this.state.confirmPassword && !this.state.validPassword ? (
                                        <FormFeedback className='animated fadeIn d-block'>
                                            <i className='fa fa-exclamation-triangle' aria-hidden='true'></i>{' '}
                                            Passwords do not match
                                        </FormFeedback>
                                    ) : (
                                        ''
                                    )}
                                </FormGroup>
                            }
                        </div>
                }
            </div>
        );
    }
}

Password.contextTypes = {
    router: PropTypes.object
}

export default Password;